import { Flex, Spacing } from '@billy/design-system'
import type { ReactElement } from 'react'

import type { InvoicingSettingsSection } from '../../../../enums/invoicingSettingsSection'
import { DocumentTypeSettingsFooterNote } from '../DocumentTypeSettingsFooterNote'
import { DocumentTypeSettingsMessage } from '../DocumentTypeSettingsMessage'
import { DocumentTypeSettingsTermsAndConditions } from '../DocumentTypeSettingsTermsAndConditions'

interface DocumentTypeSettingsTextsProps {
  trackingSection: InvoicingSettingsSection
}

export const DocumentTypeSettingsTexts = ({ trackingSection }: DocumentTypeSettingsTextsProps): ReactElement => (
  <Flex flexDirection="column" gap={Spacing.S16}>
    <DocumentTypeSettingsMessage trackingSection={trackingSection} />
    <DocumentTypeSettingsFooterNote trackingSection={trackingSection} />
    <DocumentTypeSettingsTermsAndConditions trackingSection={trackingSection} />
  </Flex>
)
